import React, { createContext } from 'react'; 

//Context item for passing data from 
export const CommentContext = createContext(); 

//Context item for passing data from renderThread.js
export const ThreadContext = createContext(); 


export const RenderAllCommentsContext = createContext(); 

//Context item for passing data from App.js
export const AppContext = createContext(); 

//Context item for CartItem 
export const CardContext = createContext(); 

//Context item for Community
export const CommunityContext = createContext(); 

//Context item for Guest panel
export const GuestContext = createContext(); 

//Context item for Create Post 
export const CreatePostContext = createContext(); 

//Context item for Home.js
export const HomeContext = createContext(); 
